import { Route } from 'vue-router';

import Recurrence from './Recurrence.vue';

import { ECheckoutStep, ENavigationGuardTypes } from '@/helpers/enums';

export default [
  {
    path: '/:contractId/remover-recorrencia/:token(.*)',
    name: 'removeRecurrence',
    component: Recurrence,
    props: (route: Route) => ({
      ...route.params,
      actionType: 'deactivate-recurrency',
    }),
    meta: {
      checkoutStep: ECheckoutStep.none,
      navigationGuardType: ENavigationGuardTypes.private,
    },
  },
  {
    path: '/:contractId/ativar-recorrencia/:token(.*)',
    name: 'enableRecurrence',
    component: Recurrence,
    props: (route: Route) => ({
      ...route.params,
      actionType: 'activate-recurrency',
    }),
    meta: {
      checkoutStep: ECheckoutStep.none,
      navigationGuardType: ENavigationGuardTypes.private,
    },
  },
];